let $ = window.jQuery;

const INPUTS = '.ev-calc-input';
const USD = '.ev-calc-formatted-input';
const BUTTON = '.ev-calc-button';
const TOOLTIP = '.ev-calc-tooltip';
const CTA = '.ev-calc-cta';

// Currency formatter
const CURRENCY = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

// Currency formatter rounded to nearest dollar
const DOLLAR = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 0,
	minimumFractionDigits: 0,
});

function onDocumentReady() {
	$(INPUTS).on('input', calculateFuelSavings);
	$(USD).on('change', formatPrice);
	$(BUTTON).on('click', updateCost);
	$(CTA).on('click', toggleSecondaryForm);
	$(TOOLTIP).tooltipster({
		theme: ['tooltipster-light', 'tooltipster-merchants', 'tooltipster-ev']
	});
}

// Calculate CV for Liquids
function calculateFuelSavings() {

	// User Input
	let miles = $('#miles').val(),
		miles_value = $('.miles-value'),
		fuel_price = $('#fuel-price'),
		fuel_price_value = fuel_price.val().replace('$', ''),
		mpg = $('#mpg').val(),
		kwh = $('#kwh').val(),
		kwh_rate = $('#kwh-rate').val().replace('$', ''),
		total_vehicles = $('#total-vehicles').val(),
		cost_label = $('.ev-calc-cost-label span');

	// Generated Values
	let cost_per_miles_ice = $('#cost-per-miles-ice'),
		cost_per_miles_ev = $('#cost-per-miles-ev'),
		fuel_cost_ice = $('#fuel-cost-ice'),
		fuel_cost_ev = $('#fuel-cost-ev'),
		savings_per_vehicle = $('#savings-per-vehicle'),
		savings_total = $('#savings-total');

	// Calculate
	let cost_per_miles_ice_value = (miles/mpg) * fuel_price_value,
		cost_per_miles_ev_value = (miles/kwh) * kwh_rate,
		fuel_cost_ice_value = (1/mpg) * fuel_price_value,
		fuel_cost_ev_value = (1/kwh) * kwh_rate,
		savings_per_vehicle_value = cost_per_miles_ice_value - cost_per_miles_ev_value,
		savings_total_value = savings_per_vehicle_value * total_vehicles;

	/**
	 * Output Results
	 */

	// display miles range value
	miles_value.text(miles);

	// update cost per miles labels
	cost_label.text(miles);

	// cost per mile ICE
	outputResult(cost_per_miles_ice_value, cost_per_miles_ice, CURRENCY);

	// cost per mile EV
	outputResult(cost_per_miles_ev_value, cost_per_miles_ev, CURRENCY);

	// fuel cost ICE
	outputResult(fuel_cost_ice_value, fuel_cost_ice, CURRENCY);

	// fuel cost EV
	outputResult(fuel_cost_ev_value, fuel_cost_ev, CURRENCY);

	// savings per vehicle
	outputResult(savings_per_vehicle_value, savings_per_vehicle, DOLLAR);

	// total savings
	outputResult(savings_total_value, savings_total, DOLLAR);
}

function updateCost() {
	let selected = $(this),
		mpg = selected.val(),
		kwh = selected.data('kwh'),
		mpg_field = $('#mpg'),
		kwh_field = $('#kwh');

	mpg_field.val(mpg);
	kwh_field.val(kwh);

	$(BUTTON).removeClass('active');
	selected.addClass('active');

	calculateFuelSavings();
}

// Format value to USD
function formatPrice() {
	let fuel_price = $('#fuel-price'),
		fuel_price_value = fuel_price.val().replace('$', ''),
		kwh_price = $('#kwh-rate'),
		kwh_price_value = kwh_price.val().replace('$', '');

	// format fuel & kwh price
	outputResult(fuel_price_value, fuel_price, CURRENCY);
	outputResult(kwh_price_value, kwh_price, CURRENCY);
}

// Check if value is number
function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

// Optional validation if needed
function validateInputs(i) {
	i.each(function () {
		let value = $(this);

		if (isNumeric(value.val())) {
			value.next('.required').remove();
		} else {
			value.next('.required').remove();
			$('<span class="required">Value must be a number</span>').insertAfter(value);
		}
	});
}

function outputResult(value, result, currency) {

	// Output result, clear if value does not validate
	if (isNumeric(value)) {
		result.val(currency.format(value));
	} else {
		result.val('');
	}
}

function toggleSecondaryForm(e) {
	let button = $(this),
		form = $('.ev-calc-form');

	if (button.hasClass('active')) {
		e.preventDefault();
	} else {
		button.addClass('active');
		form.slideDown(200);
	}

	$('html, body').animate({ scrollTop: form.offset().top - 150 }, 1000);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
